// https://trello.com/c/cDynXOXB
// Stub MediaRecorder on platforms that lack it (e.g. macOS WKWebView used by Capacitor).
// Sendbird's VoiceRecorderProvider eagerly calls MediaRecorder.isTypeSupported() on mount,
// crashing the app if it's undefined. This no-op stub lets Sendbird initialize safely while
// keeping the rest of messaging functional.
if (typeof MediaRecorder === 'undefined') {
    (window as unknown as Record<string, unknown>).MediaRecorder = class MediaRecorder extends EventTarget {
        static isTypeSupported() {
            return false;
        }
    };
}
